import BillCheck from "./bill-check.vue";
import CreateBill from "./create-bill.vue";
import BillSurvey from "./bill-survey.vue";
import ImportPayRecord from "./import-pay-record.vue";
export default {
    BillCheck: BillCheck,
    CreateBill: CreateBill,
    BillSurvey: BillSurvey,
    ImportPayRecord: ImportPayRecord
};
